// extracted by mini-css-extract-plugin
export default {"cta":"bG-z","disabled":"cG-z"};